export default "__VITE_ASSET__1dfe5395__"